import { render, staticRenderFns } from "./PopupConfirmDelete.vue?vue&type=template&id=e4b500d2&"
import script from "./PopupConfirmDelete.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirmDelete.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirmDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports